<template>
    <DCard
        padding
    >
        <Form
            :invoice-delivery-type="invoiceDeliveryType"
            :availability-types="availabilityTypes"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/InvoiceDeliveryTypes/Form'
import { route } from '~@/Composables/route'

const props = defineProps({
    invoiceDeliveryType: {
        type: Object,
        default: () => { return {} }
    },
    availabilityTypes: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

function submitData (form) {
    form.patch(route('settings.invoice-delivery-types.update', { invoice_delivery_type: props.invoiceDeliveryType.id }))
}
</script>
